export default {
  isBetween: (ab, c) => Math.min(...ab) <= c && Math.max(...ab) >= c,
  isIntersect(a, b) {
    return this.isBetween(a, b[0]) ||
      this.isBetween(a, b[1]) ||
      this.isBetween(b, a[0]) ||
      this.isBetween(b, a[1]);
  },
  join: (a, b) => [
    Math.min(Math.min(...a), Math.min(...b)),
    Math.max(Math.max(...a), Math.max(...b)),
  ],
  intersection: (a, b) => [
    Math.max(Math.min(...a), Math.min(...b)),
    Math.min(Math.max(...a), Math.max(...b)),
  ],
  subtract: (a, b) => {
    const srcBegin = Math.min(...a);
    const srcEnd = Math.max(...a);
    const subBegin = Math.min(...b);
    const subEnd = Math.max(...b);

    // sub completely includes src
    if (subBegin < srcBegin && subEnd > srcEnd) return [];

    // src completely includes sub
    if (srcBegin < subBegin && srcEnd > subEnd) {
      return [
        [srcBegin, subBegin],
        [subEnd, srcEnd],
      ];
    }

    return srcBegin > subBegin
      ? [[subEnd, srcEnd]]
      : [[srcBegin, subBegin]];
  },

  sum(original) {
    const src = [...original];
    const res = [];

    do {
      let next = src.pop();

      for (let i = 0; i < src.length; i += 1) {
        if (!this.isIntersect(src[i], next)) continue;

        src[i] = this.join(src[i], next);
        next = null;
        break;
      }

      if (next) res.push(next);
    } while (src.length);

    return res.sort((a, b) => a[0] - b[0]);
  },

  diff(original, sub) {
    const src = [...original];
    const intersections = [];

    for (let i = 0; i < src.length; i += 1) {
      if (!this.isIntersect(src[i], sub)) continue;

      intersections.push(src[i])
      src[i] = null;
    }

    const notInvolved = src.filter(a => a);
    const substracted = intersections.reduce((acc, val) => [...acc, ...this.subtract(val, sub)], []);

    return [
      ...notInvolved,
      ...substracted,
    ]
      .filter(a => a[0] !== a[1])
      .sort((a, b) => a[0] - b[0]);
  }
};
